import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import Cookie from "js-cookie";
import { getChannel } from "./tools";

const env = {
  network: null as null | "test" | "preview" | "production",
};
switch (window.location.hostname) {
  case "static.test.xiaopeng.local":
    env.network = "test";
    break;
  case "static.deploy-test.xiaopeng.com":
    env.network = "preview";
    break;
  case "static.xiaopeng.com":
    env.network = "production";
    break;
  default:
    env.network = null;
    break;
}

let environment = "dev";
if (env.network === "test") {
  environment = "test";
} else if (env.network === "preview") {
  environment = "preview";
} else if (env.network === "production") {
  environment = "production";
}

const sentryDsn =
  "https://e46ce1ed61fe446e83ac12a456b56ad3@front-monitor.xiaopeng.com/178";
const buildTime = __BUILD_TIME__;
const buildVersion = __BUILD_VERSION__;

const SentryRun = (appName: string) => {
  if (!sentryDsn) {
    console.warn("Sentry DSN is not configured");
    return;
  }

  Sentry.init({
    dsn: sentryDsn,
    // 初始参数配置内容
    integrations: [new Integrations.BrowserTracing()],
    environment: process.env.NODE_ENV === "development" ? "dev" : environment,
    release: `xp-charge-par-web@${buildVersion}`,
    debug: environment === "dev",
    // 触发异常后发送给 Sentry 的概率
    tracesSampleRate: 1.0,
  });

  const userId =
    sessionStorage.getItem("sessionUid") || Cookie.get("wasxuid_r") || "-1";
  Sentry.setTag("channel", getChannel());
  Sentry.setTag("appName", appName);
  Sentry.setTag("buildTime", buildTime);
  Sentry.setTag("buildVersionTag", buildVersion);
  Sentry.setUser({
    id: userId || "-1",
  });
};

export const sentrySetUser = (user: { id: string; [key: string]: unknown }) => {
  Sentry.setUser(user);
};

export default SentryRun;
